// extracted by mini-css-extract-plugin
export default {"test":"UserCharts_test__7m3LN"};